export const routesAdmin = [
  {
    path: "/parametre",
    name: "parametre",
    component: () => import("@/views/parametre/index.vue"),
    meta: {
      public: false,
      title: "Parametre",
      yetki: { k: [1020902] },
    },
  },
  {
    path: "/laravel_log",
    name: "laravel_log",
    component: () => import("@/views/admin/LogViewer.vue"),
    meta: {
      public: false,
      title: "laravel log",
      yetki: { p: true },
    },
  },
];
